<template>
  <div class="myfile">
    <load-list :interFace="interFace">
      <template v-slot:list="props">
        <div class="list" v-for="(v, i) in props.list" :key="i">
          <div class="item" @click="toDetailPage(v)">
            <div class="point">
              <div>督查点位：</div>
              <div>{{ v.point_name }}</div>
            </div>
            <div class="content">
              <div>考察内容：</div>
              <div>{{ v.cate_name }}</div>
            </div>
          </div>
          <div class="toolBox" v-if="v.is_operate">
            <div class="update" @click="updateFile(v)">修改</div>
            <div class="delete" @click="deleteItem(v)">删除</div>
          </div>
        </div>
      </template>
    </load-list>
  </div>
</template>
<script>
import LoadList from "@/components/SearchLoadList";
import { getInspectorList, delOrder } from "../api";
import { Dialog } from "vant";
export default {
  components: {
    LoadList,
  },
  data() {
    return {
      list: [],
      interFace: {
        api: getInspectorList,
        params: {
          is_archive: 1,
        },
      },
    };
  },
  methods: {
    toDetailPage(item) {
      this.$router.push({
        name: "fileDetail",
        query: {
          id: item.id,
        },
      });
    },
    deleteItem(item) {
      Dialog.confirm({
        title: "提示",
        message: "确认删除吗？",
      }).then(() => {
        delOrder({ id: item.id }).then((res) => {
          if (res.code == 0) {
            this.$toast.success("删除成功");
            this.$router.go(0);
          }
        });
      });
    },
    updateFile(item) {
      this.$router.push({
        name: "updateFile",
        query: {
          id: item.id,
        },
      });
    },
  },
};
</script>

<style scoped lang="less">
.myfile {
  text-align: left;
  padding: 21px 15px;
  .list {
    width: 100%;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.16);
    border-radius: 4px;
    border-left: 4px solid #0a85fe;
    margin-bottom: 10px;
    padding: 10px 13px;
    font-size: 14px;
    color: #333333;
    line-height: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .item {
      flex: 1;
      .point {
        display: flex;
        width: 270px;
        div:first-child {
          flex-shrink: 0;
          width: 1.5rem;
          height: 19px;
          line-height: 19px;
          margin-bottom: 10px;
        }
        > div:last-child {
          height: 19px;
          line-height: 19px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .content {
        display: flex;
        width: 270px;
        div:first-child {
          flex-shrink: 0;
          width: 1.5rem;
          height: 19px;
          line-height: 19px;
          margin-bottom: 10px;
        }
        > div:last-child {
          height: 65px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 4;
          word-break: break-all;
        }
      }
    }
    .toolBox {
      flex-shrink: 0;
      width: 0.97rem;
      margin-left: 10px;
      .update,
      .delete {
        width: 100%;
        height: 0.5rem;
        line-height: 0.5rem;
        text-align: center;
        border-radius: 4px;
        color: #fff;
      }
      .update {
        background: #0a85fe;
        margin-bottom: 15px;
      }
      .delete {
        background: #eb4949;
      }
    }
  }
}
</style>
